import { render, staticRenderFns } from "./PkAdd.vue?vue&type=template&id=cfb108b8&scoped=true&"
import script from "./PkAdd.vue?vue&type=script&lang=js&"
export * from "./PkAdd.vue?vue&type=script&lang=js&"
import style0 from "./PkAdd.vue?vue&type=style&index=0&id=cfb108b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb108b8",
  null
  
)

export default component.exports